import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";

/**Init load for Comment Report */
const loadFormInfo = async (ACTIONS, formInfoDispatch, handleSelectChange, handleInputTextChange, handleInputDateChange, listValues, token) => {
  formInfoDispatch({
    type: ACTIONS.SET_INITIAL_DATA,
    data: '',
    loading: true
  })

  var status = STATUSES.SUCCESS;

  // //console.log("Common Format Comment Report", listValues);

  const url = "/api/report/ct/initLoad";
  const res = await http.post(url, {}, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    // //console.log("get comment report init", res);
    /** To throw errors on 200 response status, if status != 1 or globalErrorMessageList is set*/
    if (res?.status !== 1 || (res?.globalErrorMessageList?.length > 0)) {
      status = STATUSES.ERROR;
      return Promise.reject({ status, data: res });
    }
    // -----
    const selectedCtType = listValues.ctTypesListValues(res.data);

    return {
      selectedCtType: selectedCtType,
    }

  }).then((obj) => {
    var data = {
      selectedCtType: {
        value: '',
        options: obj.selectedCtType,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleSelectChange,
        disabled: false,
        readOnly: false,
      },
      startDate: {
        value: '',
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputDateChange,
        disabled: false,
      },
      endDate: {
        value: '',
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputDateChange,
        disabled: false,
      },
      fileName: {
        value: "Common Formats Comment Report",
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      }
    }

    formInfoDispatch({
      type: ACTIONS.SET_INITIAL_DATA,
      data: data,
      loading: false
    });
  }).catch(function (error) {
    // //console.log("common format report error", error);
    status = STATUSES.ERROR;
    return Promise.reject({ status: status, data: error });
  });
};

/** Validate inputs before submit to generate report  */
const validateCtRpt = async (token, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {

  clearErrorMessages(formInfo.data);

  const selectedCtType = getFieldValue("selectedCtType", formInfo.data);
  let commentTypeId = selectedCtType.split("_")[0];
  let commentTypeName = selectedCtType.split("_")[1];

  const body = {
    "commentTypeId": commentTypeId,
    "commentTypeName": commentTypeName,
    "startDate": getFieldValue("startDate", formInfo.data),
    "endDate": getFieldValue("endDate", formInfo.data),
    "reportFileName": getFieldValue("fileName", formInfo.data),
  }

  var url = "/api/report/ct/validate";
  var status = STATUSES.SUCCESS;

  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    // //console.log("validateCtRpt() res", res);
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    // //console.log("error caught from validateCtRpt", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};


// generate comment report
const generateCtRpt = async (formInfo, token, getFieldValue) => {

  let status = STATUSES.SUCCESS;

  const selectedCtType = getFieldValue("selectedCtType", formInfo.data);
  let commentTypeId = selectedCtType.split("_")[0];
  let commentTypeName = selectedCtType.split("_")[1];

  const url = "/api/report/ct/generate";
  // reference: CommentToolReportRequest.java
  const body = {
    "commentTypeId": commentTypeId,
    "commentTypeName": commentTypeName,
    "startDate": getFieldValue("startDate", formInfo.data),
    "endDate": getFieldValue("endDate", formInfo.data),
    "reportFileName": getFieldValue("fileName", formInfo.data),
  }

  // //console.log("generateCtRpt", body);

  const res = await httpDownload.post(url, body, {
    responseType: "blob",
    headers: {
      "Authorization": token
    }
  }).then((res) => {
    // //console.log("generateCtRpt", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { loadFormInfo, validateCtRpt, generateCtRpt }